import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { NeuCard } from "../../components/neu/Neu";
import { fetchPenaltyReport } from "../../api/penaltyReport";
import { PenaltyReportHeader } from "./PenaltyReportHeader";
import { PenaltyGroups } from "./PenaltyGroups";

const HEADS = ["penalty.table.serial", "penalty.table.employee", "penalty.filters.branch",
  "penalty.table.type", "penalty.table.reason", "penalty.table.amount", "penalty.table.status",
  "penalty.table.effective"];

// تقرير العقوبات داخل صفحة التقارير — يتبع الفلاتر المشتركة (التواريخ/الفرع/الموظف).
export const PenaltyReport = ({ filters }) => {
  const { t, i18n } = useTranslation();
  const [data, setData] = useState(null);

  useEffect(() => {
    fetchPenaltyReport(filters).then(setData).catch(() => setData(null));
  }, [filters]);

  if (!data) return null;
  const ar = i18n.language === "ar";

  return (
    <NeuCard data-testid="penalty-report">
      <PenaltyReportHeader filters={filters} />

      <div className="mt-4 flex flex-wrap gap-2" data-testid="penalty-report-totals">
        {[
          ["penalty.report.count", data.totals.penalties],
          ["penalty.report.approved", data.totals.approved],
          ["penalty.report.pending", data.totals.pending],
          ["penalty.report.amount", data.totals.approved_amount],
          ["penalty.report.overrides", data.totals.overrides],
        ].map(([key, value]) => (
          <span key={key} className="rounded-full bg-primary/10 px-3 py-1 text-xs font-bold text-primary">
            {t(key)}: <span className="num">{value}</span>
          </span>
        ))}
      </div>

      <div className="mt-4">
        <PenaltyGroups data={data} />
      </div>

      {!data.rows.length ? (
        <p className="mt-4 text-sm text-muted-foreground" data-testid="penalty-report-empty">
          {t("penalty.empty")}
        </p>
      ) : (
        <div className="mt-4 overflow-x-auto">
          <table className="w-full min-w-[760px] text-start">
            <thead>
              <tr className="border-b border-border/60">
                {HEADS.map((head) => (
                  <th key={head} className="p-2 text-start text-[11px] font-black text-muted-foreground">
                    {t(head)}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.rows.map((row) => (
                <tr key={row.penalty_id} className="border-b border-border/30"
                    data-testid={`penalty-report-row-${row.penalty_id}`}>
                  <td className="p-2 num font-mono text-xs font-bold">{row.serial_number}</td>
                  <td className="p-2 text-xs font-bold">{row.employee_name}</td>
                  <td className="p-2 text-xs">{row.branch_name}</td>
                  <td className="p-2 text-xs">{ar ? row.type_ar : row.type_en}</td>
                  <td className="p-2 text-xs">{ar ? row.reason_ar : row.reason_en}</td>
                  <td className="p-2 num font-mono text-xs font-bold">{row.amount} {row.currency}</td>
                  <td className="p-2 text-xs">{t(`penalty.status.${row.status}`)}</td>
                  <td className="p-2 num font-mono text-xs" dir="ltr">{row.effective_date}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </NeuCard>
  );
};
